// Encode/decode project JSON ↔ shareable URL hash via lz-string.
// Payload disimpan di hash (#), BUKAN di query string, agar tidak
// terkirim ke server saat link dibuka dan tidak masuk server log.
//
// Privacy: lz-string = encoding, BUKAN encryption. Siapa pun yang
// punya URL bisa decode. Share modal WAJIB menampilkan privacy notice
// dan confirm opt-in sebelum encode (lihat ShareModal.js + App.js
// handleShare).

import LZString from 'lz-string'

const MAX_URL_BYTES = 100 * 1024 // 100 KB cap per implementation plan §8 risk table

export const SHARE_URL_MAX_BYTES = MAX_URL_BYTES

function getOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  return ''
}

export function encodeProjectToUrl(project, { origin } = {}) {
  if (!project || typeof project !== 'object') {
    throw new Error('encodeProjectToUrl: project is required')
  }
  const json = JSON.stringify(project)
  const compressed = LZString.compressToEncodedURIComponent(json)
  const baseUrl = (origin || getOrigin()) + '/play/'
  const url = `${baseUrl}#${compressed}`
  if (url.length > MAX_URL_BYTES) {
    const err = new Error('URL_TOO_LONG')
    err.code = 'URL_TOO_LONG'
    throw err
  }
  return url
}

export function decodeProjectFromUrl(hash) {
  const raw = hash ?? (typeof window !== 'undefined' ? window.location.hash.slice(1) : '')
  if (!raw) return null
  try {
    const json = LZString.decompressFromEncodedURIComponent(raw)
    if (!json) return null
    return JSON.parse(json)
  } catch {
    return null
  }
}

export function estimateUrlSize(project, { origin } = {}) {
  if (!project || typeof project !== 'object') return 0
  const json = JSON.stringify(project)
  const compressed = LZString.compressToEncodedURIComponent(json)
  const baseUrl = (origin || getOrigin()) + '/play/'
  return `${baseUrl}#${compressed}`.length
}

export function isUrlTooLong(project, { origin } = {}) {
  return estimateUrlSize(project, { origin }) > MAX_URL_BYTES
}
